import { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next';
import { Button } from 'rsuite'
import { useRegistration } from '../../Providers/RegistrationProvider';
import LoadingSpinner from '../../Components/Components/LoadingSpinner';
import { GiConfirmed } from "react-icons/gi"
import { ImCross } from "react-icons/im";
import { useNavigate } from 'react-router-dom';


const ConfirmAccountIndex = () => {
    const navigate = useNavigate()
    const activationCalled = useRef(false)
    const params = new URLSearchParams(window.location.search)
    const { t } = useTranslation();
    const [isLoadingActivateAccount, setIsLoadingActivateAccount] = useState(false)
    const { activateAccount } = useRegistration()
    const [headerText, setHeaderText] = useState('')
    const [bodyText, setBodyText] = useState('')
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        if (params.get("KOD") && !activationCalled.current) {
            activationCalled.current = true
            const data = {
                url: encodeURIComponent(window.location.search)
            }
            handleActivateAccount(data)
        }
    }, [])

    const handleActivateAccount = async (link) => {
        setIsLoadingActivateAccount(true)
        const res = await activateAccount(link.url)
        setHeaderText(res.result ? 'Konto zostało aktywowane!' : 'Błąd w trakcie aktywacji konta!')
        setBodyText(res.result ? res.message : res.errorMessage)
        setIsError(res.result)
        setIsLoadingActivateAccount(false)
    }

    if (isLoadingActivateAccount) {
        return <LoadingSpinner />
    }
    return (
        <>
            <div className="container main-container-holder" style={{ fontSize: '28px' }}>
                <div className="row mb-4">
                    {isError ? (<GiConfirmed size={150} className='success-text-color' />) : (<ImCross size={150} className='error-text-color' />)}
                </div>
                <div className="row text-center">
                    <span>{headerText}</span>
                </div>
                <div className="row text-center">
                    <span>{bodyText}</span>
                </div>
                <div className="row">
                    <div className='col-auto ms-auto me-5 mb-3'>
                        <Button className='btn-app-secondary' size='md' onClick={() => navigate('/login', { replace: true })}>
                            &larr;&nbsp;&nbsp;
                            {t('login_button_top_bar')}
                        </Button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ConfirmAccountIndex